import { toast } from "react-toastify";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import { useMutation, useQueryClient } from "react-query";

import ExportTranslationCacheName from "../../utils/ExportTranslationCacheName";
import { deleteTranslation } from "../../api/deleteTranslation";
import { forceReviewedStatus } from "../../api/forceReviewedStatus";

export function useForceTranslationToReview() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: forceReviewedStatus,
    onSuccess: (response) => {
      toast.success(" The selected translation has been forced to reviewed status ");
      queryClient.invalidateQueries(ExportTranslationCacheName.getExportTranslation());
    },
    onError: (error) => {
      let errorMsg = ErrorUtils.getErrorMessage(error);
      toast.error(errorMsg);
      console.error("Error submitting form:", error);
    },
  });
}
